import AxiosConfig from "../../../../../../../frontend/gui/src/axiosConfig";
import React, {useEffect, useState, useContext} from "react";
import {fabric} from "fabric";
import "../CSS Files/tooglebar.css";
import {CreationContext} from "../../../../containers/Content/CreationSuite";

export function LoadUploads (props) {

    const [uploads, setUploads] = useState([])
    const [uploadSelected, setUploadSelected] = useState("")
    const {value} = useContext(CreationContext);
    const [creationCanvas, setCreationCanvas]= value;


    useEffect(()=> {
         AxiosConfig.get('mediaManager/cs_get_uploads/')
        .then((res)=>{
            setUploads(res.data.urls)
        })

        if (uploadSelected) {

            let tempString = JSON.stringify({uploadSelected})
            let tempObj = JSON.parse(tempString);

            new fabric.Image.fromURL(tempObj.uploadSelected.uploads.trim(),
                    (img) => {creationCanvas.add(img)},
                    {crossOrigin: 'anonymous'});
            };

            creationCanvas.renderAll();

    },[uploadSelected])

    return (
        <div className = "upload-toggle">
            {uploads ? uploads.map((uploads, i)=>
                    <button key ={i+'t'}
                            onClick={() => setUploadSelected({uploads})}>
                        <img src={uploads}/>
                     </button>) : null}
        </div>
    )
}